const ProductCardSkeleton = () => {
  return (
    <div className="flex flex-col group h-full justify-between px-1 w-full animate-pulse">
      {/* Product Image Skeleton */}
      <div className="flex flex-col cursor-pointer">
        <div className="relative w-full aspect-square mb-2 rounded-tl-[32px] rounded-br-[32px] overflow-hidden bg-gray-200">
          <div className="w-full h-full bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-pulse" />
        </div>

        {/* Product Title Skeleton */}
        <div className="min-h-[40px] w-[130px] sm:w-[264px] space-y-1">
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-pulse rounded w-full" />
          <div className="h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-pulse rounded w-3/4" />
        </div>
      </div>

      <div className="w-full mt-1 pb-4 md:py-4">
        {/* Price and Rating Display Skeleton */}
        <div className="flex flex-col mb-2">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
            <div className="flex items-center gap-2">
              {/* Price skeleton */}
              <div className="h-5 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-pulse rounded w-16" />
              {/* MRP skeleton */}
              <div className="h-4 bg-gray-300 animate-pulse rounded w-20" />
            </div>
            {/* Rating skeleton */}
            <div className="mt-1 min-h-[16px] flex justify-start">
              <div className="flex items-center space-x-1">
                {Array.from({ length: 5 }, (_, index) => (
                  <div
                    key={`star-${Date.now()}-${index}`}
                    className="w-3 h-3 bg-gray-300 rounded-sm animate-pulse"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Add to Cart Button Skeleton */}
        <div className="w-full -mt-1">
          <div className="h-10 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-pulse rounded-lg w-full" />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeleton;
